/** Find the next workday after `date`, or return `date` if not in the list. */
export function nextWorkday(date: string, workdays: string[]): string {
  const idx = workdays.indexOf(date);
  if (idx >= 0 && idx < workdays.length - 1) return workdays[idx + 1];
  for (let i = 0; i < workdays.length; i++) {
    if (workdays[i] > date) return workdays[i];
  }
  return date;
}

/** Find the previous workday before `date`, or return `date` if not in the list. */
export function prevWorkday(date: string, workdays: string[]): string {
  const idx = workdays.indexOf(date);
  if (idx > 0) return workdays[idx - 1];
  for (let i = workdays.length - 1; i >= 0; i--) {
    if (workdays[i] < date) return workdays[i];
  }
  return date;
}
